import { purchasedProductCardStyles as styles } from "@insite/content-library/Components/PurchasedProductCard";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.quantityOrdered = {
    ...styles.quantityOrdered,
    cssOverrides: {
        formInputWrapper: css`
            ${styles.quantityOrdered?.css}

            input:not(.react-datetime-picker__inputGroup__input)[type="number"] {
                height: 50px;
                min-height: 50px;
            }
        `,
    },
};

styles.addToCartButton = {
    ...styles.addToCartButton,
    css: css`
        ${styles.addToCartButton?.css}

        height: 50px;
        min-height: 50px;

        ${mediaQueriesBP.minMD} {
            padding: 0 5px;
        }
    `,
};

styles.actionsContainer = {
    ...styles.actionsContainer,
    css: css`
        ${styles.actionsContainer?.css}
        margin-top: 5px;
        width: 100%;
    `,
    offsetCss: css`
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 8px;
        flex-wrap: nowrap !important;
    `,
};

styles.quantityGridItem = {
    ...styles.quantityGridItem,
    css: css`
        ${styles.quantityGridItem?.css}
        padding: 0;
        flex-basis: 35%;
        max-width: 35%;
    `,
};

styles.addToGridItem = {
    ...styles.addToGridItem,
    css: css`
        ${styles.addToGridItem?.css}
        padding: 0;
        ${mediaQueriesBP.minMD} {
            padding: 0;
            flex-basis: 80%;
        }
    `,
};
